import { createContext } from 'react';

import { QuotationGroups } from '../../../../NewQuote/containers';

interface RenewalQuotesContextProps { 
   getQuotationGroupByArticle:   (articleId: string) => QuotationGroups;
};

export const RenewalQuotesContext = createContext({} as RenewalQuotesContextProps);
